import useFetch from '@hooks/useFetch';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getIsLoggedIn } from '@api/selectors/auth';
import {
  sendParentContactOtp,
  verifyParentContactOtp
} from '@api/fetchers/parentContact';

export const PARENT_CONTACT_STATUS_KEY = 'v1/user/parent_contact/status/';

interface ParentContact {
  phone: string;
  countryCode: string;
  verifiedAt: number;
}

interface ParentContactStatus {
  hasVerifiedParentContact: boolean;
  parentContact: ParentContact | null;
}

const useParentContact = () => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);

  const {
    data: status,
    isLoading,
    mutate: refreshStatus
  } = useFetch(isLoggedIn ? PARENT_CONTACT_STATUS_KEY : null);

  const parentContactStatus = status as ParentContactStatus | undefined;

  return {
    hasVerifiedParentContact: Boolean(
      parentContactStatus?.hasVerifiedParentContact
    ),
    parentContact: parentContactStatus?.parentContact ?? null,
    isLoading,
    refreshStatus,
    sendOtp: sendParentContactOtp,
    verifyOtp: verifyParentContactOtp
  };
};

export default useParentContact;
